var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { attrs: { effect: "dark", placement: "bottom" } },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _vm._v(_vm._s(_vm.content1)),
        _c("br"),
        _c("br"),
        _vm._v(_vm._s(_vm.content2)),
        _c("br"),
        _c("br"),
        _vm._v(_vm._s(_vm.content3))
      ]),
      _c(
        "el-badge",
        {
          staticClass: "item",
          attrs: { value: _vm.count, size: "mini", max: 99 }
        },
        [
          _c(
            "el-button",
            {
              staticClass: "d2-mr btn-text can-hover",
              attrs: { type: "text" }
            },
            [
              _c("d2-icon", {
                staticStyle: { size: "15px" },
                attrs: { name: "bell" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }